/// <reference path="../../../../tools/typings/tsd.d.ts"/>
/// <reference path="../../components.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class CreditCardFormController {

        public static $inject : string[] = [
            '$mdDialog',
            'DealerwareCreditCardModel',
            '$scope',
            '$dealerwareNotification',
            '$dealerwareLoading',
            'customer',
            'creditCard',
        ];

        public hostedFieldsValidity: any;

        constructor(
                    public $mdDialog: any,
                    public creditCardModel: any,
                    public $scope: any,
                    public $dealerwareNotification: any,
                    public $dealerwareLoading: any,
                    public customer: any,
                    public creditCard: any,
                    ) {
            this.initCreditCard();

            var loader = this.$dealerwareLoading.show('Loading...');
            this.creditCardModel.clientToken({ promise: true }).then(
                (returnValue: any) => {
                    this.configureBraintreeHostedFields(returnValue.data.client_token, loader);
                    angular.element('[name=ccName]').focus();
                }
            );
        }

        public get cardholderName() : string {
            return this.creditCard.data.cardholder_name;
        }

        public set cardholderName(name: string) {
            this.creditCard.data.cardholder_name = name;
        }

        public get allowDebit() : boolean {
            return this.creditCard.data.allow_debit;
        }

        public set allowDebit(allow: boolean) {
            this.creditCard.data.allow_debit = allow;
        }

        public initCreditCard() : void {
            this.creditCard = this.creditCard || new this.creditCardModel();

            this.creditCard.data.customer_id = this.customer.customerId;
            this.creditCard.data.location_id = this.customer.locationId;
        }

        public configureBraintreeHostedFields(clientToken: string, loader: any) : void {
            braintree.client.create({
                authorization: clientToken
            }, (createErr, clientInstance) => {
                braintree.hostedFields.create({
                    client: clientInstance,
                    styles: {
                        'input': {
                            'font-family': 'Roboto, "Helvetica Neue", sans-serif',
                            'font-size': '16px',
                            'font-weight': 'normal',
                            'color': 'rgba(0, 0, 0, 0.87)'
                        },
                        ':focus': { 'color': 'rgba(0, 0, 0, 0.87)' },
                        '.valid': { 'color': 'rgba(0, 0, 0, 0.87)' },
                        '.invalid': { 'color': 'rgba(0, 0, 0, 0.87)' }
                    },
                    fields: {
                        number: {
                            selector: '#number',
                            formatInput: true,
                            placeholder: this.creditCard.data.number || '#### #### #### ####'
                        },
                        expirationDate: {
                            selector: '#expiration',
                            formatInput: true,
                            placeholder: 'MM/YYYY',
                            prefill: this.creditCard.data.expiration || undefined
                        },
                        cvv: {
                            selector: '#cvv'
                        },
                        postalCode: {
                            selector: '#postalCode'
                        }
                    }
                }, (err: any, hostedFieldsInstance: any) => {
                    if (err) {
                        loader.close();
                        this.$dealerwareNotification.error(err);
                        return;
                    }

                    hostedFieldsInstance.on('focus', (event: any) => {
                        this.handleHostedFieldFocus(event);
                    });

                    hostedFieldsInstance.on('blur', (event: any) => {
                        this.handleHostedFieldBlur(event);
                    });

                    hostedFieldsInstance.on('empty', (event: any) => {
                        this.handleHostedFieldEmpty(event);
                    });

                    hostedFieldsInstance.on('validityChange', (event: any) => {
                        this.handleHostedFieldValidityChange(event);
                    });

                    $('#creditCardForm').submit((event: any) => {
                        this.saveCreditCard(event, hostedFieldsInstance);
                    });

                    loader.close();
                    this.hostedFieldsValidity = {
                        number: false,
                        expiration: this.creditCard.data.expiration !== undefined,
                        cvv: false,
                        postalCode: false
                    };
                });
            });
        }

        public getHostedFieldLabel(field: any) : any {
            return $('.hosted-field-label[for="' + field.container.id + '"]');
        }

        public updateHostedFieldValidity(field: string, valid: boolean) : void {
            this.hostedFieldsValidity[field] = valid;
            this.$scope.$apply();
        }

        public handleHostedFieldFocus(event: any) {
            var field = event.fields[event.emittedBy];
            this.getHostedFieldLabel(field).addClass('label-float').removeClass('filled');
        }

        public handleHostedFieldBlur(event: any) : void {
            var field = event.fields[event.emittedBy],
                label = this.getHostedFieldLabel(field);

            if (field.isEmpty) {
                label.removeClass('label-float');
                this.updateHostedFieldValidity(field.container.id, false);
            } else if (field.isValid) {
                label.addClass('filled');
                this.updateHostedFieldValidity(field.container.id, true);
            } else {
                label.addClass('invalid');
                this.updateHostedFieldValidity(field.container.id, false);
            }
        }

        public handleHostedFieldEmpty(event: any) : void {
            var field = event.fields[event.emittedBy];

            this.getHostedFieldLabel(field).removeClass('filled').removeClass('invalid');
            this.updateHostedFieldValidity(field.container.id, false);
        }

        public handleHostedFieldValidityChange(event: any) : void {
            var field = event.fields[event.emittedBy],
                label = this.getHostedFieldLabel(field);

            if (field.isPotentiallyValid) {
                label.removeClass('invalid');
                this.updateHostedFieldValidity(field.container.id, true);
            } else {
                label.addClass('invalid');
                this.updateHostedFieldValidity(field.container.id, false);
            }
        }

        public disableSave() : boolean {
            var form = this.$scope.creditCardForm;

            if (!this.hostedFieldsValidity) { return false; }

            return (!form.$valid || Object.keys(this.hostedFieldsValidity).some((field) => {
                return this.hostedFieldsValidity[field] === false
            }));
        }

        public saveCreditCard(event: any, hostedFieldsInstance: any) : void {
            var loader = this.$dealerwareLoading.show('Saving...');
            event.preventDefault();

            hostedFieldsInstance.tokenize((err: any, payload: any) => {
                if (err) {
                    loader.close();
                    this.$dealerwareNotification.error(err.message);
                    return;
                }

                this.creditCard.saveCreditCard(payload.nonce)
                    .then(() => {
                        this.customer.loadCreditCards()
                            .then(() => {
                                loader.close();
                                this.$dealerwareNotification.toast('Credit card saved!');
                                this.closeModal();
                            })
                            .catch((response: any) => {
                                loader.close();
                                this.$dealerwareNotification.apiError(response);
                            });
                    })
                    .catch((response: any) => {
                        loader.close();
                        this.$dealerwareNotification.apiError(response);
                    });
            });
        }

        public closeModal() : void {
            this.$mdDialog.hide();
        }
    }

    getDealerwareWebComponentsModule().controller('CreditCardFormController', CreditCardFormController);
}
